import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import type { InlineMediaContentGapProps } from './index';

interface WrapperProps {
  $gap?: InlineMediaContentGapProps;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  gap: var(--gap, ${size(2)});

  ${({ $gap }) =>
    $gap === 'small'
      ? css`
          --gap: ${size(1)};
        `
      : css`
          --gap: ${size(2)};
        `}
`;

export const Media = styled.div`
  flex-shrink: 0;
`;

export const Body = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: ${size(0.5)};
  line-height: ${(props) => props.theme.font.lineHeight.alt};
`;
